var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.584 53.7109C11.584 52.066 12.9175 50.7324 14.5625 50.7324H55.1875C56.8324 50.7324 58.166 52.066 58.166 53.7109V68.75C58.166 70.3949 56.8324 71.7285 55.1875 71.7285H14.5625C12.9175 71.7285 11.584 70.3949 11.584 68.75V53.7109Z",
    fill: "#04131D",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7559 52.7344C12.7559 51.0895 14.0894 49.7559 15.7344 49.7559H56.1641C57.809 49.7559 59.1426 51.0895 59.1426 52.7344V67.6758C59.1426 69.3207 57.809 70.6543 56.1641 70.6543H15.7344C14.0894 70.6543 12.7559 69.3207 12.7559 67.6758V52.7344Z",
    fill: "#336570",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7559 56.9824H59.1426V67.7734C59.1426 69.4184 57.809 70.752 56.1641 70.752H15.7344C14.0894 70.752 12.7559 69.4184 12.7559 67.7734V56.9824Z",
    fill: "#8FC9D7",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4922 61.9141H28.332M17.4922 64.4531H23.1562",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4922 54.9316C18.2742 54.9316 18.9082 54.2977 18.9082 53.5156C18.9082 52.7336 18.2742 52.0996 17.4922 52.0996C16.7101 52.0996 16.0762 52.7336 16.0762 53.5156C16.0762 54.2977 16.7101 54.9316 17.4922 54.9316Z",
    fill: "#DB2A2A",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1797 54.9316C22.9617 54.9316 23.5957 54.2977 23.5957 53.5156C23.5957 52.7336 22.9617 52.0996 22.1797 52.0996C21.3976 52.0996 20.7637 52.7336 20.7637 53.5156C20.7637 54.2977 21.3976 54.9316 22.1797 54.9316Z",
    fill: "#0C6630",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8672 54.9316C27.6492 54.9316 28.2832 54.2977 28.2832 53.5156C28.2832 52.7336 27.6492 52.0996 26.8672 52.0996C26.0851 52.0996 25.4512 52.7336 25.4512 53.5156C25.4512 54.2977 26.0851 54.9316 26.8672 54.9316Z",
    fill: "white",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 20.6543H33.7031C32.0581 20.6543 30.7246 21.9878 30.7246 23.6328V55.4688C30.7246 57.1137 32.0581 58.4473 33.7031 58.4473H74.3281C75.9731 58.4473 77.3066 57.1137 77.3066 55.4688V23.6328C77.3066 21.9878 75.9731 20.6543 74.3281 20.6543Z",
    fill: "#04131D",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3047 19.6777H34.875C33.23 19.6777 31.8965 21.0113 31.8965 22.6562V54.1016C31.8965 55.7466 33.23 57.0801 34.875 57.0801H75.3047C76.9497 57.0801 78.2832 55.7466 78.2832 54.1016V22.6562C78.2832 21.0113 76.9497 19.6777 75.3047 19.6777Z",
    fill: "#336570",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8965 26.9043H78.2832V54.1016C78.2832 55.7465 76.9496 57.0801 75.3047 57.0801H34.875C33.2301 57.0801 31.8965 55.7465 31.8965 54.1016V26.9043Z",
    fill: "#DAF8FF",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4289 43.0791V54.1045C78.4289 55.8303 77.0299 57.2295 75.3039 57.2295H37.126C37.2432 57.0057 37.3811 56.7861 37.5402 56.573L45.9625 45.2959C47.8371 42.7857 51.5992 42.7857 53.4738 45.2959L57.6182 50.8453L57.7258 50.6633L67.1537 38.0395C69.0283 35.5293 72.7896 35.5281 74.6643 38.0383L78.4289 43.0791Z",
    fill: "#AEE2ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1101_12960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 36,
    width: 42,
    height: 22
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4289 43.0791V54.1045C78.4289 55.8303 77.0299 57.2295 75.3039 57.2295H37.126C37.2432 57.0057 37.3811 56.7861 37.5402 56.573L45.9625 45.2959C47.8371 42.7857 51.5992 42.7857 53.4738 45.2959L57.6182 50.8453L57.7258 50.6633L67.1537 38.0395C69.0283 35.5293 72.7896 35.5281 74.6643 38.0383L78.4289 43.0791Z",
    fill: "#9D9D9D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1101_12960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4287 43.0771H78.7217V42.9798L78.6635 42.9019L78.4287 43.0771ZM37.1258 57.2275L36.8664 57.0915L36.6416 57.5204H37.1258V57.2275ZM57.618 50.8433L57.3834 51.0185L57.6463 51.3708L57.8701 50.9923L57.618 50.8433ZM57.7256 50.6613L57.491 50.4861L57.4814 50.4986L57.4734 50.5122L57.7256 50.6613ZM78.1357 43.0771V54.1025H78.7217V43.0771H78.1357ZM78.1357 54.1025C78.1357 55.6665 76.8678 56.9345 75.3037 56.9345V57.5204C77.1914 57.5204 78.7217 55.9902 78.7217 54.1025H78.1357ZM75.3037 56.9345H37.1258V57.5204H75.3037V56.9345ZM37.3053 56.3956C37.1369 56.6212 36.9908 56.8538 36.8664 57.0915L37.3854 57.3634C37.4953 57.1534 37.6248 56.9472 37.7748 56.7462L37.3053 56.3956ZM45.7275 45.1185L37.3053 56.3956L37.7748 56.7462L46.1969 45.4691L45.7275 45.1185ZM53.7084 45.1185C51.7164 42.4515 47.7193 42.4515 45.7275 45.1185L46.1969 45.4691C47.9545 43.1159 51.4814 43.1159 53.2389 45.4691L53.7084 45.1185ZM57.8527 50.6679L53.7084 45.1185L53.2389 45.4691L57.3834 51.0185L57.8527 50.6679ZM57.4734 50.5122L57.3658 50.6941L57.8701 50.9923L57.9777 50.8105L57.4734 50.5122ZM66.9187 37.8622L57.491 50.4861L57.9604 50.8366L67.3883 38.2128L66.9187 37.8622ZM74.8988 37.8611C72.9068 35.1939 68.9105 35.1952 66.9187 37.8622L67.3883 38.2128C69.1459 35.8595 72.6719 35.8585 74.4293 38.2116L74.8988 37.8611ZM78.6635 42.9019L74.8988 37.8611L74.4293 38.2116L78.1939 43.2525L78.6635 42.9019Z",
    fill: "#04131D"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9062 39.8926C44.1984 39.8926 46.0566 38.0344 46.0566 35.7422C46.0566 33.45 44.1984 31.5918 41.9062 31.5918C39.6141 31.5918 37.7559 33.45 37.7559 35.7422C37.7559 38.0344 39.6141 39.8926 41.9062 39.8926Z",
    fill: "white",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8965 26.9043H78.2832V54.1016C78.2832 55.7465 76.9496 57.0801 75.3047 57.0801H34.875C33.2301 57.0801 31.8965 55.7465 31.8965 54.1016V26.9043Z",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6328 24.8535C37.4149 24.8535 38.0488 24.2195 38.0488 23.4375C38.0488 22.6555 37.4149 22.0215 36.6328 22.0215C35.8508 22.0215 35.2168 22.6555 35.2168 23.4375C35.2168 24.2195 35.8508 24.8535 36.6328 24.8535Z",
    fill: "#DB2A2A",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3203 24.8535C42.1024 24.8535 42.7363 24.2195 42.7363 23.4375C42.7363 22.6555 42.1024 22.0215 41.3203 22.0215C40.5383 22.0215 39.9043 22.6555 39.9043 23.4375C39.9043 24.2195 40.5383 24.8535 41.3203 24.8535Z",
    fill: "#0C6630",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0078 24.8535C46.7899 24.8535 47.4238 24.2195 47.4238 23.4375C47.4238 22.6555 46.7899 22.0215 46.0078 22.0215C45.2258 22.0215 44.5918 22.6555 44.5918 23.4375C44.5918 24.2195 45.2258 24.8535 46.0078 24.8535Z",
    fill: "white",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1797 70.8984V75.5859C22.1797 78.1748 24.2784 80.2734 26.8672 80.2734H80.1875C82.7763 80.2734 84.875 78.1748 84.875 75.5859V70.8984C84.875 68.3096 82.7763 66.2109 80.1875 66.2109H26.8672C24.2784 66.2109 22.1797 68.3096 22.1797 70.8984Z",
    fill: "#04131D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.498 69.5312V74.2188C23.498 76.7267 25.5311 78.7598 28.0391 78.7598H81.3594C83.8673 78.7598 85.9004 76.7267 85.9004 74.2188V69.5312C85.9004 67.0233 83.8673 64.9902 81.3594 64.9902H28.0391C25.5311 64.9902 23.498 67.0233 23.498 69.5312Z",
    fill: "#FDE599",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7969 71.875H29.4062",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7773 71.8984H30.3828",
    stroke: "#B78C00",
    strokeWidth: 3.51562,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6748 66.4355C82.6607 66.5037 82.6008 66.5527 82.5312 66.5527C82.4617 66.5527 82.4018 66.5037 82.3877 66.4355L81.5445 62.3148L77.4238 61.4717C77.3557 61.4576 77.3066 61.3977 77.3066 61.3281C77.3066 61.2586 77.3557 61.1986 77.4238 61.1846L81.5445 60.3414L82.3877 56.2207C82.4018 56.1525 82.4617 56.1035 82.5312 56.1035C82.6008 56.1035 82.6607 56.1525 82.6748 56.2207L83.518 60.3414L87.6387 61.1846C87.7068 61.1986 87.7559 61.2586 87.7559 61.3281C87.7559 61.3977 87.7068 61.4576 87.6387 61.4717L83.518 62.3148L82.6748 66.4355ZM28.5732 36.9434C28.5592 37.0115 28.4992 37.0605 28.4297 37.0605C28.3602 37.0605 28.3002 37.0115 28.2861 36.9434L27.443 32.8227L23.3223 31.9795C23.2541 31.9654 23.2051 31.9055 23.2051 31.8359C23.2051 31.7664 23.2541 31.7064 23.3223 31.6924L27.443 30.8492L28.2861 26.7285C28.3002 26.6604 28.3602 26.6113 28.4297 26.6113C28.4992 26.6113 28.5592 26.6604 28.5732 26.7285L29.4164 30.8492L33.5371 31.6924C33.6053 31.7064 33.6543 31.7664 33.6543 31.8359C33.6543 31.9055 33.6053 31.9654 33.5371 31.9795L29.4164 32.8227L28.5732 36.9434Z",
    fill: "white",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1777 35.1562V42.7734C70.1777 45.2814 72.2108 47.3145 74.7188 47.3145H83.1172C85.6251 47.3145 87.6582 45.2814 87.6582 42.7734V35.1562C87.6582 32.6483 85.6251 30.6152 83.1172 30.6152H74.7188C72.2108 30.6152 70.1777 32.6483 70.1777 35.1562Z",
    fill: "#04131D",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9355 34.1797V41.7969C71.9355 44.3048 73.9686 46.3379 76.4766 46.3379H84.875C87.3829 46.3379 89.416 44.3048 89.416 41.7969V34.1797C89.416 31.6718 87.3829 29.6387 84.875 29.6387H76.4766C73.9686 29.6387 71.9355 31.6718 71.9355 34.1797Z",
    fill: "#99CEDA",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1284 32.6905C80.884 32.2672 80.2731 32.2672 80.0288 32.6905L77.9991 36.2061C77.7547 36.6293 78.0602 37.1583 78.5489 37.1583H82.6083C83.0969 37.1583 83.4024 36.6293 83.1581 36.2061L81.1284 32.6905Z",
    fill: "#FF9500",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1284 38.1592C80.884 37.736 80.2731 37.736 80.0288 38.1592L77.9991 41.6749C77.7547 42.0981 78.0602 42.627 78.5489 42.627H82.6083C83.0969 42.627 83.4024 42.0981 83.1581 41.6749L81.1284 38.1592Z",
    fill: "white",
    stroke: "#04131D",
    strokeWidth: 0.292969,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploading);
export default __webpack_public_path__ + "static/media/file-uploading.f9329ce33060cc0dc47966a3ca995db3.svg";
export { ForwardRef as ReactComponent };